import type { EcxToastOptions } from '@edgeconnex/design-system'

// Only the JSON-serializable fields survive the sessionStorage round-trip; `action.onSelect`
// and `icon` would be silently dropped, so they are not part of the contract.
type StashableNotice = Pick<EcxToastOptions, 'severity' | 'summary' | 'detail' | 'life'>

const KEY = 'impersonationNotice'

// Carries the impersonation start/stop toast across the hard reload that resets identity/abilities.
export function stashImpersonationNotice(notice: StashableNotice): void {
  sessionStorage.setItem(KEY, JSON.stringify(notice))
}

export function takeImpersonationNotice(): StashableNotice | null {
  const raw = sessionStorage.getItem(KEY)
  if (!raw) return null
  sessionStorage.removeItem(KEY)
  try {
    return JSON.parse(raw) as StashableNotice
  } catch (err) {
    console.error('takeImpersonationNotice: failed to parse stashed notice', err)
    return null
  }
}
